import React, { useContext, useEffect, useState } from "react"
import PropTypes from "prop-types"
import Header from "./header"
import Footer from "./footer"
import { Alert } from "reactstrap"
import "./layout.less"
import { SpaceProfileContext } from "./SpaceProfile/context"
import axios from "axios"
import { parse } from "date-fns"
import { graphql, useStaticQuery } from "gatsby"

const Layout = ({
  children,
  mainClassName = "",
  covidAlert = false,
  mainWrapperClass = "",
}) => {
  const {
    commonData: { fetchedCommonData, customHolidays },
    actions: { setValue },
  } = useContext(SpaceProfileContext)

  const [publicH, setPh] = useState([])

  useEffect(() => {
    setValue({
      holidays: [...publicH, ...customHolidays],
    })
  }, [publicH, customHolidays])

  useEffect(() => {
    if (fetchedCommonData) return
    let isCancelled = false
    axios
      .get("https://canada-holidays.ca/api/v1/holidays")
      .then((res) => {
        if (res.data.holidays && !isCancelled) {
          const filtered_holidays = res.data.holidays.filter((holiday) => {
            return holiday.provinces && holiday.provinces.length > 0
              ? holiday.provinces.find((province) => province.id === "ON")
              : false
          })
          const publicHolidays = filtered_holidays.map((holiday) =>
            parse(holiday.observedDate, "yyyy-MM-dd", new Date())
          )
          setPh(publicHolidays)
          setValue({
            fetchedCommonData: true,
          })
        }
      })
      .catch((e) => {
        if (!isCancelled) {
          console.log("failed to get the holidays")
          console.log(e)
        }

        // notifyError(
        //   "Failed to fetch the holidays from https://canada-holidays.ca/api/v1/holidays"
        // )
      })

    return () => {
      isCancelled = true
    }
  }, [])

  return (
    <div className={`${mainWrapperClass} main-wrapper`}>
      {covidAlert && <CovidAlert covidAlert={covidAlert} />}
      <Header />
      <main className={mainClassName}>{children}</main>
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

const CovidAlert = ({ covidAlert }) => {
  const data = useStaticQuery(query)

  const banner = data.cms.banner

  const [visible, setVisible] = useState(covidAlert)

  const onDismiss = () => setVisible(false)

  if (!banner || !banner.solutionDescriptionRichText) return null

  return (
    <div className="covid-alert-wrapper">
      <div className="container text-md-center">
        <Alert color="light" isOpen={visible} toggle={onDismiss}>
          <div
            dangerouslySetInnerHTML={{
              __html: banner.solutionDescriptionRichText,
            }}
          />
        </Alert>
      </div>
    </div>
  )
}

export const query = graphql`
  query {
    cms {
      banner: entry(section: "safetyPolicies") {
        id
        ... on Cms_safetyPolicies_safetyPolicies_Entry {
          id
          solutionDescriptionRichText
        }
      }
    }
  }
`
